import { defineMessages } from '../../i18n/messages';

export const BillingMessages = defineMessages({
    PAGE_TITLE: {
        id: 'billing.page_title',
        text: 'Plan & Usage',
        description: 'Page header on the billing page',
    },
    TRIAL_ENDED_HEADER: {
        id: 'billing.trial_ended_header',
        text: 'Free tier limit reached',
        description: 'Banner heading shown when free tier words are exhausted',
    },
    TRIAL_ENDED_USAGE: {
        id: 'billing.trial_ended_usage',
        text: "You've used all 5,000 free words.",
        description: 'Banner detail shown when free tier word quota is exhausted',
    },
    TRIAL_ENDED_TIME: {
        id: 'billing.trial_ended_time',
        text: "You've used all 5,000 free words.",
        description: 'Banner detail shown when free tier words are exhausted (legacy)',
    },
    TRIAL_ENDED_CTA: {
        id: 'billing.trial_ended_cta',
        text: ' Subscribe to a plan below to continue localizing your project.',
        description: 'Call-to-action text in the trial-ended banner prompting subscription',
    },
    CURRENT_PLAN: {
        id: 'billing.current_plan',
        text: 'Current plan',
        description: 'Label for the current plan section in the plan summary card',
    },
    FREE_TRIAL: {
        id: 'billing.free_trial',
        text: 'Free Tier',
        description: 'Status value shown when user is on the free tier',
    },
    READ_ONLY: {
        id: 'billing.read_only',
        text: 'Read-only',
        description: 'Status value shown when the account is in read-only mode after trial ends',
    },
    BILLING_PERIOD: {
        id: 'billing.billing_period',
        text: 'Billing period',
        description: 'Label for the billing period field in the plan summary card for paid subscribers',
    },
    TRIAL_USAGE: {
        id: 'billing.trial_usage',
        text: 'Trial usage',
        description: 'Heading for the usage progress section during the free trial',
    },
    YEARLY_USAGE: {
        id: 'billing.yearly_usage',
        text: 'Yearly usage',
        description: 'Heading for the usage progress section for paid subscribers',
    },
    CHOOSE_PLAN: {
        id: 'billing.choose_plan',
        text: 'Choose a plan',
        description: 'Heading for the plan selection section shown to trial or unsubscribed users',
    },
    UPGRADE_PLAN: {
        id: 'billing.upgrade_plan',
        text: 'Upgrade plan',
        description: 'Heading for the plan selection section shown to existing paid subscribers',
    },
    UPGRADE_DESC: {
        id: 'billing.upgrade_desc',
        text: "Upgrade to get more yearly words. You'll only pay the prorated difference.",
        description: 'Subtitle under the upgrade plan heading for paid subscribers',
    },
    SUBSCRIBE_DESC: {
        id: 'billing.subscribe_desc',
        text: 'Subscribe to unlock continuous localization.',
        description: 'Subtitle under the choose plan heading for trial or unsubscribed users',
    },
    PLAN_FEATURES: {
        id: 'billing.plan_features',
        text: '56 locales · Unlimited storage',
        description: 'Feature summary line shown on each plan card',
    },
    FREE_CLI: {
        id: 'billing.free_cli',
        text: 'Free Localingos CLI',
        description: 'Feature line on each plan card indicating the CLI is included',
    },
    CURRENT_PLAN_BADGE: {
        id: 'billing.current_plan_badge',
        text: 'Current plan',
        description: 'Badge label on the plan card that matches the user\'s active subscription',
    },
    SUBSCRIBE_TO: {
        id: 'billing.subscribe_to',
        text: 'Subscribe to {{plan}}',
        description: 'Button text for subscribing to a plan. {{plan}} is the plan name',
    },
    UPGRADE_TO: {
        id: 'billing.upgrade_to',
        text: 'Upgrade to {{plan}}',
        description: 'Button text for upgrading to a higher plan. {{plan}} is the plan name',
    },
        MANAGE_SUBSCRIPTION: {
        id: 'billing.manage_subscription',
        text: 'Manage subscription',
        description: 'Heading for the subscription management section for paid subscribers',
    },
    OPEN_STRIPE_PORTAL: {
        id: 'billing.open_stripe_portal',
        text: 'Open Stripe billing portal',
        description: 'Button text that opens the external Stripe billing portal',
    },
});
